import { PushNotificationRequest } from "../models/PushNotificationRequest";
import { fetchWithAuthentication } from "../utilities/FetchUtil";

export const sendPushNotification = async (
    setLoading: (newValue: boolean) => void,
    pushNotificationRequest: PushNotificationRequest,
): Promise<string> => {
    setLoading(true);
    try {
        const response = await fetchWithAuthentication(
            '/notification', "POST", pushNotificationRequest
        )
        const data = await response.json();
        return data.message;
    } catch (error) {
        console.error('Error sending notifications:', error);
        return 'Something went wrong while sending the notifications';
    } finally {
        setLoading(false);
    }
};
